/* eslint-disable @typescript-eslint/no-explicit-any */
// Exchange Control (iRegistryImportSOs) contra el GraphQL de masterws: GetSummaryImportControl y sus filtros.
// Usa variables, no texto pegado en la query. Quien no es admin solo ve su empresa: lo decide el servidor
// con el userId (summaryImportControl.js), igual que el Exchange Control viejo.
import * as url from './url_helper';

const gql = async (query: string, variables: any = {}) => {
  const r = await fetch(url.API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ query, variables }),
  }).then((x) => x.json());
  if (r?.errors?.length) throw new Error(r.errors[0].message);
  return r?.data || {};
};

// El backend combina filtros con este separador de condición (Magaya/Constants: conditionSeparator + 'and').
const Y = '%%$_and';

const usuario = () => {
  try {
    return JSON.parse(localStorage.getItem('authUser') || '{}');
  } catch (e) {
    return {};
  }
};
export const esAdminHub = () => String(usuario().ROL_ID) === '19';

const armar = (filters: any, order?: string) => {
  const f: any = { initial_date: filters.from || '', final_date: filters.to || '' };
  if (order) f.order = order;
  ['reference', 'identificator', 'entity', 'taskId', 'clientId', 'status'].forEach((k) => {
    if (filters[k]) f[k] = `${filters[k]}${Y}`;
  });
  return f;
};

const LISTA = `query ($u: SummaryImportControlInput, $filters: SummaryImportControlFiltersInput, $p: PaginationInput!) {
  GetSummaryImportControl(SummaryImportControl: $u, filters: $filters, Pagination: $p) {
    CountItems
    listData { id status message resultXML text Number entity identificator clientId taskId createdAt iTask { descripcion } }
  }
}`;

export const getExchangeControl = async ({ pagination, filters, order }: any) => {
  const data = await gql(LISTA, {
    u: { userId: Number(usuario().id) || 0 },
    filters: armar(filters, order),
    p: { sizePage: pagination.sizePerPage, actualPage: pagination.page },
  });
  return data.GetSummaryImportControl || { listData: [], CountItems: 0 };
};

export const countExchangeControl = async (filters: any) => {
  const data = await gql(LISTA, {
    u: { userId: Number(usuario().id) || 0 },
    filters: armar(filters),
    p: { sizePage: 1, actualPage: 1 },
  });
  return data.GetSummaryImportControl?.CountItems || 0;
};

// Opciones de los filtros para el rango elegido. El servidor ya las limita al cliente del usuario.
// Devuelve { reference: [...], identificator: [...], ... } con { value, label }.
export const getExchangeControlOptions = async ({ from, to }: any) => {
  const u = usuario();
  const data = await gql(
    `query ($rol: String!, $user: Int, $from: String, $to: String) {
      GetSummaryImportControlFilters(rolId: $rol, userId: $user, initial_date: $from, final_date: $to) {
        filterItems { dataField data { name } }
      }
    }`,
    { rol: String(u.ROL_ID || ''), user: Number(u.id) || 0, from: from || '', to: to || '' },
  );
  const out: any = {};
  (data.GetSummaryImportControlFilters?.filterItems || []).forEach((it: any) => {
    const nombres = (it.data || []).map((d: any) => d?.name).filter(Boolean);
    // Client y Task vienen como "12 - Nombre": el filtro usa el número.
    out[it.dataField] = nombres.map((n: string) => {
      if (it.dataField === 'clientId' || it.dataField === 'taskId') {
        const [id, ...resto] = String(n).split(' - ');
        return { value: id.trim(), label: resto.length ? `${resto.join(' - ')} · #${id.trim()}` : n };
      }
      return { value: n, label: n };
    });
  });
  return out;
};
